import type { PressEvents } from '@react-types/shared'

export enum OSIcons {
  android = 'android',
  ios = 'ios',
}

export type OSIconsType = keyof typeof OSIcons

export interface WebProps {
  onAppStoreClick?: PressEvents['onPress']
  onPlayStoreClick?: PressEvents['onPress']
  platform?: OSIconsType
}
